module.exports = __webpack_public_path__ + "img/Carnotaurus_splash.bd5b1366.jpg";